import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-publish",
  "use": "icon-publish-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-publish\"><defs><style type=\"text/css\"></style></defs><path d=\"M865.28 808.96l-414.72-128 414.72-471.04-542.72 471.04-322.56-128 1024-532.48-158.72 788.48z m-419.84 189.44v-220.16l128 61.44-128 158.72z\" p-id=\"6278\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol